import url from '../../utils/config';

type Props = {
  anchor: string;
  title: string;
};

/**
 * 同一ページ内の特定アンカーへ移動するリンク項目。
 * @param param0 アンカー名と表示タイトル
 * @returns スクロールリンク項目
 */
const ScrollLinkItem = ({ anchor, title }: Props) => {
  return (
    <li className='m-list-link__item'>
      <a className='m-link' href={`#${anchor}`}>
        <img className='m-link__img' src={url('/images/icon_arrow_under.svg')} alt='' />
        {title}
      </a>
    </li>
  );
};

export default ScrollLinkItem;
